<template>
    <div class="plus-minus">
        <button class="button-circle" @click="decrease" :class="{'hide' : !canDecrease}">-</button>
        <input type="number" :value="intValue" :min="min" :max="max"/>
        <button class="button-circle" @click="increase" :class="{'hide' : !canIncrease}">+</button>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [Number],
                default: 0,
            },
            min: {
                type: [Number],
                default: 0,
            },
            max: {
                type: [Number],
                default: 1000,
            },
            step: {
                default: 1,
                type: Number
            },
        },
        data() {
            return {
                intValue: 0
            }
        },
        computed: {
            canIncrease() {
                return (this.max === undefined || ((this.intValue + this.step) <= this.max))
            },
            canDecrease() {
                return ((this.intValue - this.step) >= this.min)
            },
        },
        methods: {
            increase() {
                if (this.canIncrease) {
                    this.intValue = this.intValue + this.step
                    this.$emit('input', this.intValue)
                    this.$emit('increased')
                }
            },
            decrease() {
                if (this.canDecrease) {
                    this.intValue = this.intValue - this.step
                    this.$emit('input', this.intValue)
                    this.$emit('decreased')
                }
            }
        },
        watch: {
            value: {
                handler: function (newVal) {
                    this.intValue = newVal
                }
            }
        },
        created() {
            this.intValue = this.value

            if (this.step < 1) {
                this.step = 1
            }
            if (this.max < this.min) {
                this.max = undefined
            }
        }
    };
</script>
